import "./index.css";

function VisitorNavbar() {
  return (
    <div className="TractusNavbar">
      <div className="TractusNavbarLogoContainer">
        <div className="TractusNavbarLogo" />
      </div>
    </div>
  )
}

export default VisitorNavbar
